
export const slugifyParse = (path: string): SlugifyPlayedItemType => {
    const items = path.split("/");
    if (items.length === 2)
    {
        return {
            programSlug: items[0],
            id: parseInt(items[1].split("-")[0]),
            name: items[1].split('-').splice(1).join('-')
        }
    }
    else if (items.length === 3)
    {
        return {
            radioSlug: items[0],
            programSlug: items[1],
            id: parseInt(items[2].split("-")[0]),
            name: items[2].split('-').splice(1).join('-')
        }
    }
    return { radioSlug: items[0] };
}
